import React, { useState, useEffect } from 'react';
import { Button, Container, Form, Table, Row } from 'react-bootstrap';
import { db, /*functions*/ } from '../firebase-config';
 //import { httpsCallable } from 'firebase/functions';
import { collection, query, where, getDocs, doc, updateDoc } from "firebase/firestore";
// import { useNavigate } from 'react-router-dom';

import { useAuth } from '../Context/AuthContext';
import StatusSpinner from '../Components/StatusSpinner';

// const navigate = useNavigate();
import { toast } from 'react-toastify';

export default function EmployeeTechSettings() {
  const { showSpinner, setShowSpinner } = useAuth();
  const [userAdminStatusEmail, setUserAdminStatusEmail] = useState('');
  const [listOfAdminEmails, setListOfAdminEmails] = useState([""]);
  const [employeeInfo, setEmployeeInfo] = useState([]);

  useEffect(()=>{
      setShowSpinner(true);
      getDocs(collection(db, "technicians")).then((snapShot)=>{
          let emailList = [""];
          let employeeTempInfo = [];
          snapShot.forEach((doc)=>{
              if(doc.data()?.deleted === undefined || !doc.data()?.deleted){
                emailList.push(doc.data().email);
                employeeTempInfo.push({...doc.data(), id: doc.id});
              }
          });
          return {emailList: emailList, empInfo: employeeTempInfo};
      }).then((info)=>{
          setShowSpinner(false);
          setListOfAdminEmails(info.emailList);
          setEmployeeInfo(info.empInfo);
      }).catch((error)=>{
          setShowSpinner(false);
          toast.error(`Error getting employee email list: ${error.message}`);
      });
  }, [setShowSpinner]);

  const handleCreateTechClick = ()=>{
    const index = employeeInfo.findIndex((info) => info.email === userAdminStatusEmail);
    if(employeeInfo[index].access === "none" || employeeInfo[index].access === "inactive"){
      const techRef = doc(db, "technicians", employeeInfo[index].id);
      setShowSpinner(true);
      updateDoc(techRef, {access: "technician"}).then(()=>{
        setShowSpinner(false);
        let tempEmployeeInfo = [...employeeInfo];
        tempEmployeeInfo[index] = {
          ...tempEmployeeInfo[index],
          'access': 'technician',
        }
        setEmployeeInfo(tempEmployeeInfo);
        toast.success(`${userAdminStatusEmail} has been updated`);
        setUserAdminStatusEmail('');
      }).catch((error)=>{
          setShowSpinner(false);
          toast.error(`Error saving ${userAdminStatusEmail} access: ${error.message}`);
      });
    }
  };

  const handleRevokeTechClick = async ()=>{
    const index = employeeInfo.findIndex((info) => info.email === userAdminStatusEmail);

    const requestsQuery = query(collection(db, 'requests'), where("work_order.assigned_techs", "array-contains", employeeInfo[index].id));
    let danger = [];
    try{
      const querySnapshot = await getDocs(requestsQuery);
      querySnapshot.forEach((doc)=>{
        danger.push(doc.data());
      })
    } catch(error){
      console.log(error);
    }
    
    
    if(employeeInfo[index]?.access === "technician" && employeeInfo[index]?.work_orders?.length === 0 && danger.length === 0){
      const techRef = doc(db, "technicians", employeeInfo[index].id);
      setShowSpinner(true);
      updateDoc(techRef, {access: "inactive"}).then(()=>{
        setShowSpinner(false);
        let tempEmployeeInfo = [...employeeInfo];
        tempEmployeeInfo[index] = {
          ...tempEmployeeInfo[index],
          'access': 'inactive',
        }
        setEmployeeInfo(tempEmployeeInfo);
        toast.success(`${userAdminStatusEmail} has been updated`);
        setUserAdminStatusEmail('');
      }).catch((error)=>{
          setShowSpinner(false);
          toast.error(`Error saving ${userAdminStatusEmail} access: ${error.message}`);
      });
    } else if(employeeInfo[index]?.work_orders?.length > 0 || danger.length > 0){
      toast.error(`${employeeInfo[index].tech_name} has one or more work orders associated with their account. Please remove all work orders from their account and try again.`);
    }
  };

  return(
    <>
      <Container fluid style={{width:"100%",paddingLeft:"65px", marginRight:"65px"}}>
          <Container fluid className="mt-5" style={{fontSize:"1.5em", letterSpacing:"0.2em"}}>
              <Row className="justify-content-center">
                  TECHNICIAN SETTINGS
              </Row>
          </Container>
      </Container>
      <Container fluid className="d-flex align-items-center justify-content-center" style={{width:"100%", paddingLeft:"70px", marginRight:"70px"}}>
          <div className="w-100" style={{maxWidth: "600px"}}>
              <div className="mt-5">
                  <Form.Group  style={{textAlign:"left"}} id="admin-set-email">
                      <Form.Label>Email to add/revoke technician access</Form.Label>
                      <Form.Select value={userAdminStatusEmail} onChange={(event)=>{
                          setUserAdminStatusEmail(event.target.value)
                      }}>
                          {
                              listOfAdminEmails.map((email, index)=>{
                                  return(<option key={index} value={email}>{email}</option>)
                              })
                          }
                      </Form.Select>
                  </Form.Group>
              </div>
              {
                  (employeeInfo.find(({email}) => email === userAdminStatusEmail)?.access === 'none' || employeeInfo.find(({email}) => email === userAdminStatusEmail)?.access === 'inactive') ?
                      <div className="mt-3">
                        <Button
                          className="btn-dark"
                          style={{backgroundColor:"#2596be", margin:5}}
                          onClick={handleCreateTechClick}
                        >
                          Create Technician
                        </Button>
                      </div>
                  :
                      employeeInfo.find(({email}) => email === userAdminStatusEmail)?.access === 'technician' ?
                          <div className="mt-3">
                            <Button
                              className="btn-dark"
                              style={{backgroundColor:"#2596be", margin:5}}
                              onClick={handleRevokeTechClick}
                            >
                              Revoke Technician
                            </Button>
                          </div>
                      :
                          ''
              }
          </div>
      </Container>
      <Container fluid className="d-flex align-items-center justify-content-center" style={{width:"100%", paddingLeft:"70px", marginRight:"70px"}}>
        <div className="w-100" style={{maxWidth: "600px"}}>
          <div className="mt-5">
            <Table>
              <thead>
                <tr>
                  <th>Employee Name</th>
                  <th>Email</th>
                  <th>Technician Access</th>
                </tr>
              </thead>
              <tbody>
                {
                  employeeInfo.map((employee, index)=>{
                      return(
                        <tr
                          key={index}
                          style={{cursor:"pointer"}}
                          onClick={() => setUserAdminStatusEmail(employee.email)}
                        >
                          <td>{employee?.tech_name}</td>
                          <td>{employee?.email}</td>
                          <td style={{color:
                                  employee?.access === undefined ?
                                      "red" 
                                  :
                                      employee.access === "technician" ?
                                          "green"
                                      :
                                          "red"
                              }}
                          >{employee?.access !== undefined ? employee.access : "none"}</td>
                        </tr>
                    )
                  })
                }
              </tbody>
            </Table>
          </div>
        </div>
        {
          showSpinner &&
            <StatusSpinner />
        }
      </Container>
    </>
  )
}